import { create } from 'zustand'
import type { Session, User } from '@supabase/supabase-js'
import { getSupabase, initSupabase } from '@/lib/supabase'

interface AuthState {
  user: User | null
  session: Session | null
  loading: boolean
  initialized: boolean

  // Actions
  initialize: () => Promise<void>
  setSession: (session: Session | null) => void
  signOut: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  session: null,
  loading: true,
  initialized: false,

  initialize: async () => {
    if (get().initialized) return

    try {
      const supabase = await initSupabase()

      // Get initial session
      const { data: { session } } = await supabase.auth.getSession()

      set({
        session,
        user: session?.user ?? null,
        loading: false,
        initialized: true
      })

      // Listen for auth changes
      supabase.auth.onAuthStateChange((_event, session) => {
        set({
          session,
          user: session?.user ?? null
        })
      })
    } catch (error) {
      console.error('Failed to initialize auth:', error)
      set({ loading: false, initialized: true })
    }
  },

  setSession: (session) => {
    set({
      session,
      user: session?.user ?? null
    })
  },

  signOut: async () => {
    const supabase = getSupabase()
    await supabase.auth.signOut({ scope: 'global' })
    set({ session: null, user: null })
  }
}))
